export const deepEqual = (a: Object, b: Object) => {
  return JSON.stringify(a) === JSON.stringify(b);
};
